export default __webpack_public_path__ + "static/media/accounting_point_9_vn.9a58b48d.png";